import * as AppActions from "../../actions/appAction";
import FetchError from "../../../api/errors";
import { logError, leaveBreadcrumb } from "../../../utils/tracker";
import { store } from "../../store";
import { isElectron } from "../../../utils/miscUtils";

export function showErrorMessage(error: FetchError | Error, context?: Record<string, any>): void {
    if (error) {
        console.log('error', error);

        // Log error to Bugsnag with context
        const errorMetadata: Record<string, any> = {
            errorType: (error as FetchError).type,
            errorMessage: error.message,
            ...context
        };

        logError(error, errorMetadata);

        leaveBreadcrumb('Error occurred', {
            message: error.message,
            type: (error as FetchError).type,
            ...context
        }, 'error');

        if ((error as FetchError).type === "existing-user") {
            console.log("You have an existing account - please log in.");
        } else if ((error as FetchError).type === 401) {
            console.log("Unauthorized user");
            leaveBreadcrumb('User logged out due to 401 error', {}, 'state');
            if (isElectron()) {
                store.dispatch(AppActions.setCloudAuthStatus({
                    status: 'invalid',
                    reason: 'api_401',
                    updatedAt: Date.now(),
                }));
            } else {
                store.dispatch(AppActions.forceLogout());
            }
        } else if ((error as FetchError).type === 500) {
            console.log("There was an error. Please try again in a few seconds.");
        }
    }
}

export const showSuccessMessage = (text?: string) => {
    if (text) {
        console.log(text);
    }
};
